import ease from '@/constants/ease';
import cn from 'classnames';
import { AnimatePresence, motion } from "framer-motion";
import Image from "next/image";

export const BumperImage = ({ additionalClasses = '' }: { additionalClasses?: string }) => {
  return (
    <Image
      src="https://front.com/webassets/rebrand/promo-banner.webp"
      alt=""
      className={cn(additionalClasses, "w-full")}
      width={585}
      height={322}
    />);
}

export const BumperImageAnimatedPopover = ({ hasSeen, className }: { hasSeen: boolean, className?: string }) => {
  return (
    <AnimatePresence>
      {hasSeen && (
        <motion.div
          initial={{ opacity: 0, y: '100%' }}
          animate={{ opacity: 1, y: 0 }}
          transition={{
            ease: ease.appear,
            duration: 400 / 1000,
            delay: 800 / 1000,
          }}
          className={className}
        >
          <Image src="https://front.com/webassets/rebrand/bumper-notification.svg" alt="" width={430} height={63} className="w-full h-auto" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
